export default "__VITE_ASSET__CLHJ82Qv__"